"use strict";

exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _uncontrollable = require("uncontrollable");
var _Tabs = _interopRequireDefault(require("@restart/ui/Tabs"));
var _Nav = _interopRequireDefault(require("./Nav"));
var _NavLink = _interopRequireDefault(require("./NavLink"));
var _NavItem = _interopRequireDefault(require("./NavItem"));
var _TabContent = _interopRequireDefault(require("./TabContent"));
var _TabPane = _interopRequireDefault(require("./TabPane"));
var _ElementChildren = require("./ElementChildren");
var _getTabTransitionComponent = _interopRequireDefault(require("./getTabTransitionComponent"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["id", "onSelect", "transition", "mountOnEnter", "unmountOnExit", "variant", "children", "activeKey"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getDefaultActiveKey(children) {
  var defaultActiveKey;
  (0, _ElementChildren.forEach)(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}
function renderTab(child) {
  var _child$props = child.props,
    title = _child$props.title,
    eventKey = _child$props.eventKey,
    disabled = _child$props.disabled,
    tabClassName = _child$props.tabClassName,
    tabAttrs = _child$props.tabAttrs,
    id = _child$props.id;
  if (title == null) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavItem.default, {
    as: "li",
    role: "presentation",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavLink.default, _objectSpread(_objectSpread({
      as: "button",
      type: "button",
      eventKey: eventKey,
      disabled: disabled,
      id: id,
      className: tabClassName
    }, tabAttrs), {}, {
      children: title
    }))
  });
}
var Tabs = function Tabs(props) {
  var _useUncontrolled = (0, _uncontrollable.useUncontrolled)(props, {
      activeKey: 'onSelect'
    }),
    id = _useUncontrolled.id,
    onSelect = _useUncontrolled.onSelect,
    transition = _useUncontrolled.transition,
    _useUncontrolled$moun = _useUncontrolled.mountOnEnter,
    mountOnEnter = _useUncontrolled$moun === void 0 ? false : _useUncontrolled$moun,
    _useUncontrolled$unmo = _useUncontrolled.unmountOnExit,
    unmountOnExit = _useUncontrolled$unmo === void 0 ? false : _useUncontrolled$unmo,
    _useUncontrolled$vari = _useUncontrolled.variant,
    variant = _useUncontrolled$vari === void 0 ? 'tabs' : _useUncontrolled$vari,
    children = _useUncontrolled.children,
    _useUncontrolled$acti = _useUncontrolled.activeKey,
    activeKey = _useUncontrolled$acti === void 0 ? getDefaultActiveKey(children) : _useUncontrolled$acti,
    controlledProps = _objectWithoutProperties(_useUncontrolled, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Tabs.default, {
    id: id,
    activeKey: activeKey,
    onSelect: onSelect,
    transition: (0, _getTabTransitionComponent.default)(transition),
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Nav.default, _objectSpread(_objectSpread({
      id: id
    }, controlledProps), {}, {
      role: "tablist",
      as: "ul",
      variant: variant,
      children: (0, _ElementChildren.map)(children, renderTab)
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TabContent.default, {
      children: (0, _ElementChildren.map)(children, function (child) {
        var childProps = _objectSpread({}, child.props);
        delete childProps.title;
        delete childProps.disabled;
        delete childProps.tabClassName;
        delete childProps.tabAttrs;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TabPane.default, _objectSpread({}, childProps));
      })
    })]
  });
};
Tabs.displayName = 'Tabs';
var _default = exports.default = Tabs;